<div #repdiv fxFlexFill class="disable-scroll"></div>
<inner-loader [isActive]="isLoadingResults"></inner-loader>
